import { useNavigate } from "react-router-dom";

import DashboardLayout from "../../components/layout/DashboardLayout";

import {
  useMenuViewModel,
} from "../../viewmodels/menu/useMenuViewModel";

import {
  useContactViewModel,
} from "../../viewmodels/website/useContactViewModel";

const DashboardPage = () => {
  const navigate = useNavigate();

  const { menus } = useMenuViewModel();

  const { unreadCount } = useContactViewModel();

  return (
    <DashboardLayout>
      <div className="p-4 md:p-6 space-y-8">

        {/* HEADER */}
        <div>
          <h1 className="text-3xl font-bold text-slate-800">
            ERP Dashboard
          </h1>

          <p className="text-gray-500 mt-1">
            Business management overview
          </p>
        </div>

        {/* ERP MODULES */}
        <div className="space-y-8">

          {menus.map((menu: any) => {

            const hasChildren =
              menu.children &&
              menu.children.length > 0;

            if (!hasChildren) {
              return null;
            }

            const isWebsite =
              menu.name?.toLowerCase() === "website";

            return (
              <div
                key={menu.id}
                className="bg-white rounded-3xl shadow border border-slate-200 overflow-hidden"
              >

                {/* SECTION HEADER */}
                <div className="px-6 py-5 border-b bg-gradient-to-r from-slate-50 to-slate-100">
                  <h2 className="text-xl font-bold text-slate-800">
                    {menu.name}
                  </h2>

                  <p className="text-sm text-gray-500 mt-1">
                    {menu.children.length} modules
                  </p>
                </div>

                {/* MODULE GRID */}
                <div className="p-4">

                  <div className="md:grid md:grid-cols-2 xl:grid-cols-4 md:gap-4 flex gap-4 overflow-x-auto md:overflow-visible pb-2">

                    {menu.children.map((child: any) => {

                      const isRequests =
                        isWebsite &&
                        child.name?.toLowerCase() === "requests";

                      return (
                        <button
                          key={child.id}
                          onClick={() => navigate(child.route)}
                          className="min-w-[260px] md:min-w-0 bg-slate-50 hover:bg-primary border border-slate-200 hover:border-primary rounded-2xl p-5 transition-all duration-200 text-left group flex-shrink-0"
                        >

                          <div className="flex items-start justify-between">

                            {/* LEFT */}
                            <div>
                              <div className="flex items-center gap-3">

                                <div className="text-lg font-semibold text-slate-800 group-hover:text-white transition">
                                  {child.name}
                                </div>

                                {/* UNREAD REQUEST COUNT */}
                                {isRequests && unreadCount > 0 && (
                                  <span
                                    className="min-w-[24px] h-6 px-2 flex items-center justify-center rounded-full bg-red-500 text-white text-xs font-bold"
                                  >
                                    {unreadCount}
                                  </span>
                                )}

                              </div>

                              <div className="text-sm text-gray-500 group-hover:text-white/80 mt-2 transition">
                                Open module
                              </div>
                            </div>

                            {/* RIGHT ICON */}
                            <div className="w-11 h-11 rounded-2xl bg-white group-hover:bg-white/20 flex items-center justify-center text-lg text-slate-700 group-hover:text-white transition">
                              →
                            </div>

                          </div>

                        </button>
                      );
                    })}

                  </div>

                </div>

              </div>
            );
          })}

        </div>

      </div>
    </DashboardLayout>
  );
};

export default DashboardPage;